import { useA11yStore } from '../../store/a11yStore';

/**
 * The app's only two live regions. Mounted once, at the top of <App />, and fed exclusively
 * through useAnnounce(). Everything else in the UI should be plain markup.
 *
 * Note there is no `role` on either element. `role="status"` carries an implicit
 * aria-live="polite", and pairing it with an explicit aria-live="assertive" makes NVDA and
 * JAWS disagree about which wins — the previous game-board markup hit exactly that.
 */
export default function LiveRegions() {
  const polite = useA11yStore((s) => s.polite);
  const assertive = useA11yStore((s) => s.assertive);

  return (
    <>
      <div aria-live="polite" aria-atomic="true" className="sr-only">
        {polite}
      </div>
      <div aria-live="assertive" aria-atomic="true" className="sr-only">
        {assertive}
      </div>
    </>
  );
}
